var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Alert.tsx
import { forwardRef } from "react";
import { default as MUIAlert } from "@mui/material/Alert";
import { IconButton } from "@availity/mui-button";
import { InfoCircleIcon, WarningCircleIcon, SuccessCircleIcon, CloseIcon } from "@availity/mui-icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AlertIcons = {
  error: /* @__PURE__ */ jsx(WarningCircleIcon, { color: "error" }),
  info: /* @__PURE__ */ jsx(InfoCircleIcon, { color: "info" }),
  success: /* @__PURE__ */ jsx(SuccessCircleIcon, { color: "success" }),
  warning: /* @__PURE__ */ jsx(WarningCircleIcon, { color: "warning", sx: { color: "warning.dark" } })
};
var Alert = forwardRef((allProps, ref) => {
  const _a = allProps, { action, onClose, closeText = "dismiss alert" } = _a, args = __objRest(_a, ["action", "onClose", "closeText"]);
  const ComboActionClose = (args2) => /* @__PURE__ */ jsxs(Fragment, { children: [
    action,
    /* @__PURE__ */ jsx(IconButton, __spreadValues({ size: "small" }, args2))
  ] });
  const slots = {
    closeButton: action ? ComboActionClose : IconButton,
    closeIcon: CloseIcon
  };
  return /* @__PURE__ */ jsx(
    MUIAlert,
    __spreadValues({
      variant: "standard",
      action: onClose ? void 0 : action,
      onClose,
      closeText,
      iconMapping: AlertIcons,
      slots,
      ref
    }, args)
  );
});

// src/lib/AlertTitle.tsx
import { default as MUIAlertTitle } from "@mui/material/AlertTitle";
import { jsx as jsx2 } from "react/jsx-runtime";
var AlertTitle = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx2(MUIAlertTitle, __spreadProps(__spreadValues({}, rest), { children }));
};
export {
  Alert,
  AlertIcons,
  AlertTitle
};
